module.exports = __webpack_public_path__ + "b72d45d251272c81460fd3a2a58454d0.png";